module.exports = __webpack_public_path__ + "img/img_brand10.b7b46bf5.jpg";